import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/app/products/[productId]/AddToCart.tsx");
;
import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/app/products/[productId]/ProductDetailsClient.tsx");
;
import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/node_modules/next/dist/client/image-component.js");
